import { Box, ButtonProps, Flex, forwardRef, IconButton, rem, Text, Tooltip } from '@bonusly/design-system';

import { useActionInput } from '../../context';

interface DecorationButtonProps extends ButtonProps {
	label: string;
	decorationVariant: 'default' | 'list-item';
}

export const DecorationButton = forwardRef<DecorationButtonProps, 'div'>(({ label, onClick, decorationVariant, ...rest }, ref) => {
	const { startDraft } = useActionInput();

	if (decorationVariant === 'list-item') {
		return (
			<Flex
				key={label}
				onClick={(e) => {
					startDraft();
					onClick?.(e as any);
				}}
				cursor="pointer"
				alignItems="center"
				p={3}
				width="100%"
				borderRadius="sm"
				transition="all 0.2s"
				_hover={{ bg: 'bg.canvas' }}
			>
				<Box fontSize={rem(24)} color="info.text" display="flex" alignItems="center">
					{rest.children}
				</Box>
				<Text as="span" color="info.text" ml={2} fontSize="md" fontWeight="medium">
					{label}
				</Text>
			</Flex>
		);
	}
	return (
		<Box ref={ref}>
			<Tooltip label={label}>
				<IconButton
					aria-label={label}
					borderRadius={rem(10)}
					boxSize={rem(40)}
					color="gray.700"
					fontSize={rem(24)}
					onClick={(e) => {
						startDraft();
						onClick?.(e);
					}}
					_hover={{
						background: 'gray.25',
					}}
					{...rest}
				/>
			</Tooltip>
		</Box>
	);
});
